import { render, staticRenderFns } from "./productCenList.vue?vue&type=template&id=73be89aa&scoped=true&"
import script from "./productCenList.vue?vue&type=script&lang=js&"
export * from "./productCenList.vue?vue&type=script&lang=js&"
import style1 from "./productCenList.vue?vue&type=style&index=1&id=73be89aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be89aa",
  null
  
)

export default component.exports